/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { I18NextNs } from 'enum/enum';
import { FormProvider, useForm } from 'react-hook-form';
import { useLocation } from 'react-router';
import { RouterDOM, FnAxios, FnDialog, I18n } from 'utilities/utilities';
import { Grid } from '@mui/material';
import { BtnBack, BtnDraft, BtnSave } from 'components/Button/ButtonAll';

import _ from "lodash";
import moment from 'moment';
import TablePaymentSoldTicket from '../components/Payment/TablePaymentSoldTicket';
import TablePaymentAdd from '../components/Payment/TablePaymentAdd';
import TablePaymentSummary from '../components/Payment/TablePaymentSummary';
import { ProviderAccPayment } from '../AccountingPayment/AccountingPaymentForm';
import ApproveCheckTicket from '../components/ApproveCheckTicket';
import { ProviderSoldTicket } from '../TicketSold/TicketSoldForm';
import { TextBoxItem } from 'components/Input/TextBox';
import { GetMenuPermissionParamRoute } from 'utilities/SystemFunction';


const AccountingFundForm = () => {


    //#region Hook
    const Router = RouterDOM();
    const AxiosFn = FnAxios()
    const DialogFn = FnDialog();
    const location = useLocation();
    // #endregion

    const objParamPath = useMemo(() => {
        const ParamId = new URLSearchParams(location.search).get("strParam");
        const ParamPrs = 2;
        return { ParamId, ParamPrs }
    }, [location.search])

    //#region State / Usememo
    const [isPermission, setIsPermission] = useState<boolean>(false);
    const onClearAttachFile = useRef(null);
    const onClearDepositSlip = useRef(null);
    const [arrAttachmentList, setArrAttachmentList] = useState([])
    const [arrDepositSlip, setArrDepositSlip] = useState([])
    const [isView, setIsView] = useState(false)

    const [objValue, setObjValue] = useState({
        lstSoldTicket: [],
        arrSelectTicketSold: [],
        nAmountTicketSold: 0,
        lstRent: [],
        nAmountRent: 0,
        lstDonate: [],
        nAmountDonate: 0,
    })

    //#region Form
    const form = useForm({
        shouldFocusError: true,
        shouldUnregister: false,
        mode: "all",
        defaultValues: {
            sMuseum: null,
            sNameDeposit: null,
            dDatePayment: null,
            dDateDeposit: null,
            sRemark: null,
            sApprove: null,
            nStartDate: null,
            nEndDate: null,
        }
    });
    // #endregion

    const objProvider = React.useMemo(() => (
        {
            isView: true,
            form,
            onClearDepositSlip,
            arrDepositSlip,
            setArrDepositSlip,
            objValue,
            setObjValue
        }
    ), [form, arrDepositSlip, objValue]);

    const objProviderApprove = React.useMemo(() => (
        {
            isView : isPermission ? isView : true,
            form,
            arrAttachmentList,
            setArrAttachmentList,
            onClearAttachFile
        }
    ), [isView,isPermission, form, arrAttachmentList, setArrAttachmentList, onClearAttachFile]);


    useEffect(() => {
        GetMenuPermissionParamRoute("/AccountingFundList", AxiosFn, setIsPermission, DialogFn);
    }, []);


    useEffect(() => {
        getFormInfoPayment()
    }, [])

    const gotoBack = () => {
        Router.GoToPage("/AccountingFundList")
    }

    const handleSubmitForm = () => {

        form.clearErrors()

        let objParam = {
            sMode: form.getValues("sApprove"),
            sIDPayment: objParamPath.ParamId,
            sRemark: form.getValues("sRemark"),
            lstSelectTicketSold: [],
            lstRent: [],
            lstDonate: [],
            lstFile: [],
        };

        DialogFn.Submit(I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            AxiosFn.Post(`PaymentTicket/OnSubmitTicketAccountingFund`, objParam, () => {
                DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                    gotoBack();
                });
            });
        });
    }

    const getFormInfoPayment = () => {
        if (objParamPath.ParamId) {
            DialogFn.BlockUI();
            AxiosFn.Get(`PaymentTicket/GetFormInfoPayment`, { sPaymentID: objParamPath.ParamId }, (result) => {
                DialogFn.UnBlockUI();
                let lstTicketSold = result.objResult.lstTicketSold
                let lstSelectTicketSold = result.objResult.lstSelectTicketSold
                let objPayment = result.objResult.objPayment;
                setIsView(objPayment.nStatusID !== 1)
                form.setValue("sMuseum", objPayment.sMuseum)
                form.setValue("sNameDeposit", objPayment.sNameDeposit)
                form.setValue("dDatePayment", moment(objPayment.nDatePayment))
                form.setValue("dDateDeposit", moment(objPayment.nDateDeposit))
                form.setValue("nStartDate", moment(objPayment.nStartDate))
                form.setValue("nEndDate", moment(objPayment.nEndDate))
                //// not wait approve
                let sStatusID = objPayment.nStatusID + "";
                if (sStatusID !== "1") {
                    form.setValue("sApprove", sStatusID === "3" ? "A" : "R")
                    form.setValue("sRemark", objPayment.sRemark)
                }

                setArrDepositSlip(objPayment.lstFile)
                setObjValue(value => {
                    return ({
                        ...value,
                        lstSoldTicket: lstTicketSold,
                        arrSelectTicketSold: lstSelectTicketSold,
                        nAmountTicketSold: objPayment.nAmountTicketSold,
                        lstRent: objPayment.lstRent,
                        nAmountRent: objPayment.nAmountRent,
                        lstDonate: objPayment.lstDonate,
                        nAmountDonate: objPayment.nAmountDonate,
                    })
                })
            });
        }
    };

    return (
        <FormProvider {...form}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8}>
                    <TextBoxItem
                        name={"sMuseum"}
                        id={"sMuseum"}
                        label={"พิพิธภัณฑ์"}
                        maxLength={250}
                        type={"text"}
                        required={false}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} md={5}>
                    <TextBoxItem
                        name={"sNameDeposit"}
                        id={"sNameDeposit"}
                        label={"ผู้นำฝาก"}
                        maxLength={250}
                        type={"text"}
                        required={false}
                        disabled
                    />
                </Grid>
                <Grid item xs={12}>
                    <ProviderAccPayment.Provider value={objProvider} >
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TablePaymentSoldTicket menu={"Fund"} sIDPayment={objParamPath.ParamId} getPaymentSoldTicket={null}/>
                            </Grid>
                            <Grid item xs={12}>
                                <br />
                                <TablePaymentAdd isRent={true} />
                            </Grid>
                            <Grid item xs={12}>
                                <br />
                                <TablePaymentAdd isRent={false} />
                            </Grid>
                            <Grid item xs={12}>
                                <TablePaymentSummary />
                            </Grid>
                        </Grid>
                    </ProviderAccPayment.Provider>
                </Grid>
                <Grid item xs={12}>
                    <ProviderSoldTicket.Provider value={objProviderApprove} >
                        <ApproveCheckTicket isCommittee={false} isPermission={isView ? false : isPermission} />
                    </ProviderSoldTicket.Provider>
                </Grid>
                <Grid item xs={12}></Grid>
                <Grid item xs={12}>
                    <Grid
                        container
                        spacing={2}
                        justifyContent={"space-between"}
                        alignItems={"start"}
                    >
                        <Grid item>
                            <BtnBack id={"btnback-ticket"} onClick={() => gotoBack()} />
                        </Grid>
                        <Grid item>
                            {isView || !isPermission ? null :
                                <BtnSave
                                    id={"btnsave-ticket"}
                                    onClick={form.handleSubmit(() => handleSubmitForm())}
                                />
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </FormProvider>
    )
}

export default AccountingFundForm